module.exports = ".canvas-container {\r\n    width: 100%;\r\n    position: relative;\r\n    padding-bottom: 56.25%; /* Aspect ratio 16:9 */\r\n}\r\n\r\ncanvas {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/utilidades/firma/firma.component.css
// module id = ./src/app/utilidades/firma/firma.component.css
// module chunks = main